import { useState } from 'react';
import ModalImagem from './ModalImagem/ModalImagem';

export const SocialNetwork = ({ data, handleImage, setDataImage, error, onChange }) => {
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState(null);

  const handleCloseImage = () => {
    setShowImage(false);
  };

  const loadImage = (event) => {
    const file = event.target.files[0];
    const user = JSON.parse(localStorage.getItem('user'));
    setImage(file);
    setShowImage(true);
    setDataImage({
      originalName: file.name,
      alias: user.id + '_photoprofile',
      companyId: user.companyId,
      employeeId: user.id,
      feature: 'Profile',
    });
  };

  return (
    <>
      <ModalImagem show={showImage} handleClose={handleCloseImage} setImage={setImage} image={image} handleImage={handleImage} />
      <div className="content-form">
        <div className="row">
          <div className="col">
            <h3>Redes sociales y Foto</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-2 d-flex align-items-center">
            <label>Foto de perfil</label>
          </div>
          <div className="col-xl-8 col-lg-9 col-md-8 d-flex align-items-center">
            <p>Las fotos ayudan a personalizar tu perfil y facilitan que otros te identifiquen.</p>
          </div>
          <div className="col-xl-2 col-md-3">
            <input type="file" name="" id="imageLoad" onChange={loadImage} />
            <div className="img">
              <label className="label-image" htmlFor="imageLoad">
                <img src={image || data.profile_image || data.image || 'https://assets.mydna.company/b2b-images/image_default.png'} alt="" />
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="facebook">Facebook</label>
            <input type="text" name="facebook" id="facebook" onChange={onChange} value={data.facebook || ''} />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="instagram">Instagram</label>
            <input type="text" name="instagram" id="instagram" onChange={onChange} value={data.instagram || ''} />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="linkedin">LinkedIn</label>
            <input type="text" name="linkedin" id="linkedin" onChange={onChange} value={data.linkedin || ''} />
          </div>
        </div>
      </div>
    </>
  );
};
